// FutureFridges: invented maker of commercial refrigeration. The mark is a mountain peak cut from an ice crystal.
export function FutureFridgesMark({ size = 40, glow = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" style={glow ? { filter: 'drop-shadow(0 6px 22px rgba(79,195,247,.45))' } : null}>
      <defs><linearGradient id="fg-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#7FD8FA" /><stop offset="1" stop-color="#2A8CC4" /></linearGradient></defs>
      <path d="M32 3 57 17.5v29L32 61 7 46.5v-29Z" fill="#0E2A47" />
      <path d="M32 3 57 17.5v29L32 61 7 46.5v-29Z" fill="none" stroke="url(#fg-g)" stroke-width="2.5" />
      <path d="M12 44 25 24l6 8 7-13 14 25Z" fill="url(#fg-g)" />
      <path d="M38 19l-4 8 4-2 3 3Z M25 24l-3 6 3-1.5 2.5 2.5Z" fill="#E8F7FE" />
      <path d="M32 9v6M29 12h6M30 10l4 4M34 10l-4 4" stroke="#E8F7FE" stroke-width="1.4" stroke-linecap="round" />
    </svg>
  );
}
export function GiothubMark({ size = 18 }) {
  return <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#5EB7D6" /><path d="M16 6v20M7.3 11l17.4 10M7.3 21l17.4-10" stroke="#0A2B3A" stroke-width="2.6" stroke-linecap="round" /></svg>;
}
